//TODO : Refactor after ai
import type { HTMLAttributes, ReactNode } from "react";
import type { OverviewView } from "./types";

const GLYPH: Record<OverviewView, ReactNode> = {
  list: (
    <>
      <path d="M8 6h13M8 12h13M8 18h13" />
      <path d="M3.5 6h.01M3.5 12h.01M3.5 18h.01" />
    </>
  ),
  table: (
    <>
      <rect x="3" y="4.5" width="18" height="15" rx="2" />
      <path d="M3 9.5h18M3 14.5h18M9.5 9.5v10" />
    </>
  ),
  gallery: (
    <>
      <rect x="3" y="4" width="7.5" height="7.5" rx="1.5" />
      <rect x="13.5" y="4" width="7.5" height="7.5" rx="1.5" />
      <rect x="3" y="12.5" width="7.5" height="7.5" rx="1.5" />
      <rect x="13.5" y="12.5" width="7.5" height="7.5" rx="1.5" />
    </>
  ),
  kanban: (
    <>
      <rect x="3" y="4" width="5" height="16" rx="1.5" />
      <rect x="9.5" y="4" width="5" height="11" rx="1.5" />
      <rect x="16" y="4" width="5" height="14" rx="1.5" />
    </>
  ),
  map: (
    <>
      <path d="M9 3.5 3.5 5.5v15L9 18.5l6 2 5.5-2v-15L15 5.5z" />
      <path d="M9 3.5v15M15 5.5v15" />
    </>
  ),
  calendar: (
    <>
      <rect x="3.5" y="5" width="17" height="15" rx="2" />
      <path d="M8 3v4M16 3v4M3.5 10h17" />
    </>
  ),
  summary: (
    <>
      <path d="M4 19V9M10 19V5M16 19v-6M4 19h17" />
    </>
  ),
  plan: (
    <>
      <rect x="3" y="5" width="9" height="4" rx="1.5" />
      <rect x="8" y="10.5" width="12" height="4" rx="1.5" />
      <rect x="5" y="16" width="8" height="4" rx="1.5" />
    </>
  ),
};

const LABEL: Record<OverviewView, string> = {
  list: "Liste",
  table: "Tabelle",
  gallery: "Galerie",
  kanban: "Kanban",
  map: "Karte",
  calendar: "Kalender",
  summary: "Mengen",
  plan: "Plan",
};

export interface ViewSwitcherProps
  extends Omit<HTMLAttributes<HTMLDivElement>, "onChange"> {
  views?: OverviewView[];
  value?: OverviewView;
  onChange?: (view: OverviewView) => void;
}

/** Icon-only switch between an overview's representations. */
export function ViewSwitcher({
  views = [
    "list", "table", "gallery", "kanban", "map", "calendar", "summary", "plan",
  ],
  value,
  onChange,
  className = "",
  ...rest
}: ViewSwitcherProps) {
  return (
    <div className={`bui-ov-views ${className}`} role="group" aria-label="Ansicht" {...rest}>
      {views.map((view) => (
        <button
          key={view}
          type="button"
          className="bui-ov-view"
          title={LABEL[view]}
          aria-label={LABEL[view]}
          aria-pressed={view === value}
          onClick={() => onChange?.(view)}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            {GLYPH[view]}
          </svg>
        </button>
      ))}
    </div>
  );
}
